import { Provider } from "react-redux";
import { NotificationContainer } from "react-notifications";
import { RouterProvider } from "react-router-dom";
import { WPToastNotification } from "./packages/WPToastNotification";
import CAStore from "./Store/TemplateStore/template.store";
import { UnsavedChangesProvider } from "./hooks/useUnsavedChanges";

import { router } from "./Routes.js";

import "./styles/vendors/style.js";

export const store = CAStore;

window.onbeforeunload = (event) => {
  event.preventDefault();
  event.returnValue = "";
};

function App() {
  return (
    <Provider store={store}>
      <UnsavedChangesProvider>
        <RouterProvider router={router} />
      </UnsavedChangesProvider>

      <NotificationContainer />
      <WPToastNotification />
    </Provider>
  );
}

export default App;
